import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(0.5),
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    backgroundColor: theme.palette.black,
    color: theme.palette.white,
    fontSize: '11px',
    lineHeight: 1.4,
    textAlign: 'center',

    [theme.breakpoints.up('medium')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(3),
      padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
      fontSize: '13px',
      textAlign: 'left',
    },
  },
  helpLink: {
    color: theme.palette.white,
    textDecoration: 'none',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  copyright: {
    opacity: 0.8,
  },
}));

export default useStyles;
